/**
 * Le informazioni della partita fuori dalla testata: competizione, luogo,
 * formato e note. Prima del fischio le apre in un dialog la voce del menu «⋯»;
 * a partita conclusa stanno nella scheda Info (`ElencoInformazioni`).
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export interface DatiInfoPartita {
  avversario: string;
  inCasa: boolean;
  competizione: string;
  luogo: string | null;
  note: string | null;
}

type FormatoInfo = { nPeriodi: number; durataPeriodoMin: number; giocatoriInCampo: number };

/** Competizione, luogo e formato in un elenco a due colonne, sotto le note se ci sono. */
export function ElencoInformazioni({
  partita,
  formato,
}: {
  partita: DatiInfoPartita;
  /** Assente finché non è caricato: la riga del formato non compare. */
  formato?: FormatoInfo;
}) {
  const voci: [string, string][] = [
    ['Competizione', partita.competizione],
    ['Luogo', partita.luogo ?? '—'],
  ];
  if (formato) {
    voci.push([
      'Formato',
      `${formato.nPeriodi} × ${formato.durataPeriodoMin}′, ${formato.giocatoriInCampo} in campo`,
    ]);
  }
  return (
    <div className="flex flex-col gap-3 text-sm">
      <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2">
        {voci.map(([etichetta, valore]) => (
          <div key={etichetta} className="contents">
            <dt className="text-muted-foreground">{etichetta}</dt>
            <dd className="break-words">{valore}</dd>
          </div>
        ))}
      </dl>
      {partita.note && (
        <div className="flex flex-col gap-1">
          <h3 className="text-muted-foreground">Note</h3>
          <p className="break-words whitespace-pre-line">{partita.note}</p>
        </div>
      )}
    </div>
  );
}

export function InfoPartita({
  partita,
  formato,
  aperto,
  onChiudi,
}: {
  partita: DatiInfoPartita;
  formato: FormatoInfo;
  aperto: boolean;
  onChiudi: () => void;
}) {
  return (
    <Dialog open={aperto} onOpenChange={(v) => !v && onChiudi()}>
      <DialogContent className="max-h-[90dvh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Informazioni</DialogTitle>
          <DialogDescription>
            {partita.inCasa ? 'Casa' : 'Trasferta'} · {partita.avversario}
          </DialogDescription>
        </DialogHeader>
        <ElencoInformazioni partita={partita} formato={formato} />
      </DialogContent>
    </Dialog>
  );
}
